import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  APP_SETTING_UPDATE_IP_ADDRESSES_BEGIN,
  APP_SETTING_UPDATE_IP_ADDRESSES_SUCCESS,
  APP_SETTING_UPDATE_IP_ADDRESSES_FAILURE,
  APP_SETTING_UPDATE_IP_ADDRESSES_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
export function updateIpAddresses(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_UPDATE_IP_ADDRESSES_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/update-ip`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: APP_SETTING_UPDATE_IP_ADDRESSES_SUCCESS,
            data: res,
          });
          toast.success('Updated Successfully!');
          resolve(res);
        },
        (err) => {
          dispatch({
            type: APP_SETTING_UPDATE_IP_ADDRESSES_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}
export function dismissUpdateIpAddressesError() {
  return {
    type: APP_SETTING_UPDATE_IP_ADDRESSES_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_UPDATE_IP_ADDRESSES_BEGIN:
      return {
        ...state,
        updateIpAddressesPending: true,
        updateIpAddressesError: null,
      };

    case APP_SETTING_UPDATE_IP_ADDRESSES_SUCCESS:
      return {
        ...state,
        updateIpAddressesPending: false,
        updateIpAddressesError: null,
      };

    case APP_SETTING_UPDATE_IP_ADDRESSES_FAILURE:
      return {
        ...state,
        updateIpAddressesPending: false,
        updateIpAddressesError: action.data.error,
      };

    case APP_SETTING_UPDATE_IP_ADDRESSES_DISMISS_ERROR:
      return {
        ...state,
        updateIpAddressesError: null,
      };

    default:
      return state;
  }
}
